import { action, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { idCounter } from "./util";

@observer
export class PluginComponentRenderer extends React.Component {
  render() {
    return pluginComponentStore.pluginComponents.map(
      ({ Component, key, animationProps }) => {
        return <Component animationProps={animationProps} key={key} />;
      }
    );
  }
}

export interface IPluginComponent {
  Component: any;
  animationProps: { isOpen: boolean };
  key: string;
}

export class PluginComponentStore {
  @observable pluginComponents: IPluginComponent[] = [];

  @action add = (Component, key = "PluginComponent" + idCounter()) => {
    this.pluginComponents.push({
      Component,
      animationProps: {
        isOpen: true,
      },
      key,
    });

    return key;
  };

  @action remove = (key: string) => {
    const index = this.pluginComponents.findIndex((c) => c.key === key);

    if (index > -1) {
      this.pluginComponents.splice(index, 1);
    }
  };

  indexOfKey = (key: string) => {
    return this.pluginComponents.findIndex((c) => c.key === key);
  };
}

export const pluginComponentStore = new PluginComponentStore();

export interface IPluginProps {
  animationProps: {
    isOpen: boolean;
  };
}
